import { render, staticRenderFns } from "./DisciplinaryGrid.vue?vue&type=template&id=718048ed"
import script from "./DisciplinaryGrid.vue?vue&type=script&lang=js"
export * from "./DisciplinaryGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports